<template>
  <div class="order-list-local">
    <!-- 顶部导航栏 -->
    <van-nav-bar title="本地订单查询" left-arrow @click-left="onClickLeft" fixed />

    <!-- 查询条件 -->
    <div class="search-form">
      <van-field
        v-model="searchForm.idCard6"
        label="身份证后6位"
        placeholder="请输入身份证后六位"
        clearable
        maxlength="6"
      />
      <van-field
        v-model="searchForm.mobile"
        label="联系手机号"
        placeholder="请输入联系手机号"
        clearable
        maxlength="11"
      />
      <div class="search-buttons">
        <van-button color="#1989fa" size="normal" @click="handleSearch">
          查询
        </van-button>
        <van-button plain color="#1989fa" size="normal" @click="handleReset">
          重置
        </van-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="order-content">
      <!-- 无数据提示 -->
      <div v-if="orderList.length === 0 && hasSearched" class="no-data">
        <van-empty description="暂无订单数据" />
      </div>
      
      <!-- 订单卡片 -->
      <div
        class="order-item"
        v-for="order in orderList"
        :key="order.orderId"
      >
        <div class="order-header">
          <span class="order-id">订单号：{{ order.orderId }}</span>
          <van-tag :type="getStatusType(order.status)" size="medium">
            {{ order.status || '未知状态' }}
          </van-tag>
        </div>
        
        <div class="order-info">
          <div class="info-row">
            <span class="label">系统订单号：</span>
            <span class="value">{{ order.sysOrderNo || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="label">开卡手机号：</span>
            <span class="value">{{ order.mobile || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="label">套餐名称：</span>
            <span class="value">{{ order.comboName || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="label">联系人：</span>
            <span class="value">{{ order.cardName || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="label">身份证号：</span>
            <span class="value">{{ order.cardNo || '-' }}</span>
          </div>
          <!-- <div class="info-row">
            <span class="label">归属地：</span>
            <span class="value">{{ order.cardAttribution || '-' }}</span>
          </div> -->
          <div class="info-row">
            <span class="label">收货地址：</span>
            <span class="value">{{ order.address || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="label">物流单号：</span>
            <span class="value">{{ order.expressNo || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="label">下单时间：</span>
            <span class="value">{{ formatTime(order.orderTime) }}</span>
          </div>
        </div>

        <div class="order-actions">
          <van-button
            plain
            type="info"
            size="small"
            @click="viewOrderDetail(order)"
          >
            查看详情
          </van-button>
        </div>
      </div>
    </div>

    <!-- 订单详情弹窗 -->
    <van-dialog
      v-model="showDetailPopup"
      title="订单详情"
      :show-confirm-button="true"
      confirmButtonColor="#1989fa"
      confirmButtonText="关闭"
    >
      <div class="detail-content" v-if="currentOrder">
        <div class="detail-item">
          <span class="detail-label">订单号：</span>
          <span class="detail-value">{{ currentOrder.orderId }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">系统订单号：</span>
          <span class="detail-value">{{ currentOrder.sysOrderNo || '-' }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">开卡手机号：</span>
          <span class="detail-value">{{ currentOrder.mobile || '-' }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">套餐名称：</span>
          <span class="detail-value">{{ currentOrder.comboName || '-' }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">联系人：</span>
          <span class="detail-value">{{ currentOrder.cardName || '-' }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">身份证号：</span>
          <span class="detail-value">{{ currentOrder.cardNo || '-' }}</span>
        </div>
        <!-- <div class="detail-item">
          <span class="detail-label">归属地：</span>
          <span class="detail-value">{{ currentOrder.cardAttribution || '-' }}</span>
        </div> -->
        <div class="detail-item">
          <span class="detail-label">收货地址：</span>
          <span class="detail-value">{{ currentOrder.address || '-' }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">物流单号：</span>
          <span class="detail-value">{{ currentOrder.expressNo || '-' }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">订单状态：</span>
          <span class="detail-value">
            <van-tag :type="getStatusType(currentOrder.status)" size="medium">
              {{ currentOrder.status || '未知状态' }}
            </van-tag>
          </span>
        </div>
        <div class="detail-item">
          <span class="detail-label">下单时间：</span>
          <span class="detail-value">{{ formatTime(currentOrder.orderTime) }}</span>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import { http } from "@/api/http";
import { NavBar, Tag, Field, Button, Dialog, Empty } from "vant";

// 注册组件
Vue.use(NavBar).use(Tag).use(Field).use(Button).use(Dialog).use(Empty);

export default {
  name: "OrderListLocal",

  data() {
    return {
      // 查询条件
      searchForm: {
        idCard6: "",
        mobile: "",
      },
      // 订单列表
      orderList: [],
      // 弹窗控制
      showDetailPopup: false,
      // 当前查看的订单
      currentOrder: null,
      // 是否已经搜索过
      hasSearched: false,
    };
  },

  created() {
    // 从路由参数获取 spiId
    this.spiId = this.$route.params.spiId || this.$route.query.spiId;
    if (!this.spiId) {
      this.$toast("缺少必要参数：spiId");
      this.$router.back();
    }
  },

  methods: {
    // 返回上一页
    onClickLeft() {
      this.$router.back();
    },

    // 获取订单状态类型
    getStatusType(status) {
      if (!status) return "default";
      
      const statusMap = {
        "-1": "作废",
        "0": "待确认",
        "1": "已下单",
        "2": "已完成"
      };
      
      return statusMap[status] || "default";
    },

    // 格式化时间
    formatTime(time) {
      if (!time) return "-";
      try {
        const date = new Date(time);
        if (isNaN(date.getTime())) return time; // 如果解析失败，直接返回原值
        
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      } catch (e) {
        return time;
      }
    },

    // 处理查询
    async handleSearch() {
      if (!this.searchForm.idCard6 && !this.searchForm.mobile) {
        this.$toast("请至少输入身份证后6位或联系手机号");
        return;
      }

      if (this.searchForm.idCard6 && this.searchForm.idCard6.length !== 6) {
        this.$toast("身份证后6位必须是6位数字或字母");
        return;
      }

      if (this.searchForm.mobile && !/^1[3-9]\d{9}$/.test(this.searchForm.mobile)) {
        this.$toast("请输入正确的手机号码");
        return;
      }

      try {
        const params = {
          idCard6: this.searchForm.idCard6,
          mobile: this.searchForm.mobile,
          spiId: this.spiId,
        };

        console.log("查询参数：", params);
        
        const { code, result, message } = await http("queryDbOrder", params);
        
        if (code === 200) {
          console.log("查询结果：", result);
          this.orderList = Array.isArray(result) ? result : [];
          this.hasSearched = true;
          
          if (this.orderList.length === 0) {
            this.$toast("未查询到相关订单");
          }
        } else {
          this.orderList = [];
          this.hasSearched = true;
          this.$toast(message || "查询失败");
        }
      } catch (error) {
        console.error("查询出错：", error);
        this.$toast("查询出错，请稍后重试");
        this.orderList = [];
        this.hasSearched = true;
      }
    },

    // 处理重置
    handleReset() {
      this.searchForm.idCard6 = "";
      this.searchForm.mobile = "";
      this.orderList = [];
      this.hasSearched = false;
    },

    // 查看订单详情
    viewOrderDetail(order) {
      this.currentOrder = order;
      this.showDetailPopup = true;
    },
  },
};
</script>

<style lang="less" scoped>
.order-list-local {
  min-height: 100vh;
  background-color: #f7f8fa;
  padding-top: 46px;

  .search-form {
    background-color: #fff;
    padding: 16px;
    margin-bottom: 10px;
    border-radius: 8px;
    margin: 10px;

    .search-buttons {
      display: flex;
      justify-content: center;
      padding: 16px 0 0 0;
      gap: 15px;

      .van-button {
        width: 120px;
        height: 40px;
        font-size: 16px;
      }
    }
  }

  .order-content {
    padding: 10px;

    .no-data {
      padding: 40px 0;
    }
  }

  .order-item {
    background-color: #fff;
    padding: 16px;
    margin-bottom: 12px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    .order-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
      padding-bottom: 12px;
      border-bottom: 1px solid #f0f0f0;

      .order-id {
        font-size: 16px;
        font-weight: 600;
        color: #333;
      }
    }

    .order-info {
      .info-row {
        margin-bottom: 8px;
        font-size: 14px;
        display: flex;
        align-items: flex-start;

        &:last-child {
          margin-bottom: 0;
        }

        .label {
          color: #666;
          width: 90px;
          flex-shrink: 0;
        }

        .value {
          color: #333;
          flex: 1;
          word-break: break-all;
        }
      }
    }

    .order-actions {
      display: flex;
      justify-content: flex-end;
      margin-top: 16px;
      padding-top: 16px;
      border-top: 1px solid #f0f0f0;

      .van-button {
        min-width: 90px;
      }
    }
  }
}

.detail-content {
  padding: 20px;

  .detail-item {
    margin-bottom: 16px;
    font-size: 14px;
    display: flex;
    align-items: flex-start;

    &:last-child {
      margin-bottom: 0;
    }

    .detail-label {
      color: #666;
      width: 90px;
      flex-shrink: 0;
    }

    .detail-value {
      color: #333;
      flex: 1;
      word-break: break-all;
    }
  }
}
</style>
